<template>
  <div
    :class="{
      collapsed: !inActivePath || collapsed,
      active: isActivePath,
      bulleted: false,
      'active-dropzone-variant':
        activeDropzone && canDropVariant && draggingElementIsVariant == true && !draggingElementIsSentence
    }"
    class="sentence"
    @drop="handleDrop($event, sentence)"
    @dragover.prevent="activeDropzone = true"
    @dragenter.prevent="activeDropzone = true"
    @dragleave.prevent="handleDragLeave()"
    @dragend.prevent="handleDragendScenario()"
    :draggable="activeDragHandle"
    @dragstart="dragScenario($event, sentence)"
    ref="sentence"
  >
    <div
      class="dropzone-top"
      :class="{
        'show-dropzone':
          draggingPriority >= sentence.priority &&
          draggingValidation &&
          !isOwnDropZone &&
          !linkedAbove &&
          !enteredNestedElement
      }"
    ></div>
    <div class="line-number" :class="isActivePath && !collapsed ? 'active-line-number' : ''">
      {{ visiblePath.join(".") }}
    </div>
    <div
      ref="sentenceHeader"
      class="sentence-header"
      :class="{
        'open-not-active': unlinkTemplateSection && !collapsed && pathIsSameLevel,
        'showing-priority': showPriority
      }"
    >
      <span class="toggle-collapse" @click="toggleActive">
        <span v-show="caretDown"> <i class="fa-light fa-chevron-down"></i></span>
        <span v-show="!caretDown"> <i class="fa-light fa-chevron-right"></i></span>
      </span>
      <!-- <template v-if="hasSiblingScenarios"> -->

      <div @click="toggleActive" class="sentence-header-content">
        <span class="ellipsis">{{ $t("sentence.scenario") }} {{ visiblePath[visiblePath.length - 1] }} </span>
        <div
          v-show="linkedBelow || linkedAbove"
          class="linked-icon"
          :tooltip="showTooltips ? (linkedBelow ? $t('sentence.linked-below') : $t('sentence.linked-above')) : ''"
          tooltip-placement="right"
          @click.stop="
            handleAction($event, 'default', () => {
              ungroupPriority(sentence);
            })
          "
        >
          <i class="fa-light fa-link-simple"></i>
        </div>
        <icon-base
          v-if="!sentence.sentenceList.empty"
          class="icon-converted"
          iconStrokeWidth="1"
          iconStroke="#fff"
          iconColor="none"
          width="16"
          height="16"
          icon-name="Name"
          ><icon-converted
        /></icon-base>

        <span class="sentence-name ellipsis"> {{ sentence.name ? ": " + sentence.name : "" }} </span>
        <span v-if="!sentence.name && !$store.state.showingTemplateBackupInPreview" class="text-muted rename no-name">
          {{ $t("sentence.noname") }}
        </span>
        <div
          v-if="!isDemo && !$store.state.showingTemplateBackupInPreview"
          @click.stop="editName()"
          class="rename-wrapper"
        >
          <a v-show="!sentence.name" class="rename add"> {{ $t("sentence.add") }}</a>
          <span v-show="sentence.name" class="rename pencil">
            <i class="fa-light fa-pen"></i>
          </span>
        </div>
      </div>
      <div class="actions" v-if="!$store.state.showingTemplateBackupInPreview">
        <div
          v-if="!isDemo"
          class="sentence-action drag-grip"
          :class="{ 'is-dragging': draggingScenario }"
          @mousedown="activeDragHandle = true"
          @mouseleave="activeDragHandle = false"
        >
          <i class="fa-light fa-grip-dots-vertical"></i>
        </div>
        <div
          class="sentence-action"
          @click="
            handleAction($event, 'default', () => {
              $emit('remove');
            })
          "
          :tooltip="showTooltips ? $t('sentence.delete') : ''"
          tooltip-placement="left"
        >
          <i class="fa-light fa-trash"></i>
        </div>
        <dropdown
          left
          class="sentence-action"
          :tooltip="showTooltips ? $t('sentence.add-new') : ''"
          tooltip-placement="left"
          :darkBackground="true"
          :disabled="isDemo"
        >
          <div @click="handleAction($event, 'createNew')" slot="toggle">
            <i class="fa-light fa-plus"></i>
          </div>
          <sentence-add-elements-list 
            :sentence="sentence"
            @on-add-variant="onAddVariant()"
            @add-scenario-above="$emit('add-scenario-above')"
            @add-scenario-below="$emit('add-scenario-below')"
            @add-table-above="$emit('add-table-above')"
            @add-table-below="$emit('add-table-below')"
            @add-row-below="$emit('add-row-below')"
            @add-cell-below="$emit('add-cell-below')"
            @add-list-below="$emit('add-list-below')"
            @add-list-item-below="$emit('add-list-item-below')"
          />
        </dropdown>
        <div
          v-if="canConvert"
          class="sentence-action convert-sentence"
          @click="
            handleAction($event, 'convertScenario', () => {
              onConvertToSentence(variantCounter, true);
            })
          "
          :tooltip="showTooltips ? $t('sentence.convert') : ''"
          tooltip-placement="left"
        >
          <i class="fa-light fa-level-up-alt"></i>
        </div>
        <div
          v-if="!isDemo"
          class="sentence-action"
          :tooltip="showTooltips ? $t('duplicate-below') : ''"
          tooltip-placement="left"
          @click.stop="cloneBelow()"
        >
          <i class="fa-light fa-clone"></i>
        </div>

        <div v-if="showPriority && sentence.number == sentenceNumber" class="priority" @click="avoidCollapse">
          <input
            type="number"
            id="quantity"
            name="quantity"
            min="0"
            max="999"
            @change="newPriorityNumber(sentence.priority)"
            v-model="sentence.priority"
          />
        </div>
      </div>
    </div>
    <condition-list
      v-if="!unlinkTemplateSection ? isActivePath && !collapsed : pathIsSameLevel && !collapsed"
      class="flex-grow-1"
      :condition-list="sentence.conditionList"
      :condition-operator="sentence.conditionOperator"
      :can-add-variant="sentence.sentenceList.empty"
      @remove-sentence="$emit('remove')"
      @add-variant="onAddVariant"
      @change="$emit('change')"
    />
    <div
      class="variant-adder"
      v-if="inActivePath && !collapsed && sentence.variantList.empty && sentence.sentenceList.empty"
    >
      <a @click.stop.prevent="onAddVariant()"> + {{ $t("sentence.variant") }}</a>
    </div>
    <div
      class="variants-and-sentences"
      :style="{ 'padding-left': false ? '11px' : '11px' }"
      @dragover.prevent="enteredNestedElement = true"
      @dragenter.prevent="enteredNestedElement = true"
      @dragleave.prevent="enteredNestedElement = false"
    >
      <variant-list
        v-if="showVariants"
        :can-add="!subSentences.length && isActivePath"
        :variant-list="sentence.variantList"
        :sentenceId="sentence.id"
        @convert-to-sentence="onConvertToSentence"
        @change="onVariantChange"
        @variant-count="variantCount"
        :showRawHTML="showRawHTML"
        ref="variantList"
      />

      <sentence-list
        v-if="showSentences"
        :sentence-list="sentence.sentenceList"
        :visible-path="visiblePath"
        :active-path="activePath"
        :unlinkTemplateSection="unlinkTemplateSection"
        :showRawHTML="showRawHTML"
        :templateSectionCopy="templateSectionCopy"
        @change="$emit('change')"
      />
    </div>
    <div
      class="dropzone-bottom"
      :class="{
        'show-dropzone':
          draggingPriority < sentence.priority && draggingValidation && !linkedBelow && !enteredNestedElement
      }"
    ></div>
  </div>
</template>

<script>
import VariantList from "@/components/VariantList";
import EventBus from "@/assets/js/eventBus.js";
import RenameModal from "@/components/modals/RenameModal";
import Dropdown from "@/components/Dropdown";
import SentenceAddElementsList from "@/components/SentenceAddElementsList";
import IconBase from "@/components/icons/IconBase";
import IconConverted from "@/components/icons/IconConverted";
import ConfirmModal from "@/components/modals/ConfirmModal";
import { editorMixin } from "@/assets/js/editorMixin.js";
export default {
  name: "sentence",
  mixins: [editorMixin],
  data() {
    return {
      collapsed: false,
      newPriority: this.priority,
      variantCounter: null,
      activeDropzone: false,
      activeDragHandle: false,
      draggingScenario: false,
      wasOpen: null,
      draggedParentId: null,
      enteredNestedElement: false
    };
  },
  props: {
    sentence: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    visiblePath: {
      type: Array,
      required: true
    },
    activePath: {
      type: Array,
      required: true
    },
    hasSiblingScenarios: {
      type: Boolean
    },
    unlinkTemplateSection: {
      type: Boolean
    },
    parentSentencePath: Array,
    priority: [Number, String],
    showPriority: Boolean,
    sentenceNumber: String,
    scenarioIndex: [Number, String],
    draggingIndex: [Number, String],
    draggingPriority: [Number, String],
    templateSectionCopy: Object,
    showRawHTML: Boolean,
    scenarioGroupPriorities: Array,
    scenarioGroupNumber: [Number, String]
  },
  computed: {
    canConvert(){
      return ["Sentence", undefined].includes(this.sentence.sentenceType);
    },
    showVariants(){
      return this.unlinkTemplateSection
        ? !this.sentence.variantList.empty && !this.collapsed
        : !this.sentence.variantList.empty && this.isActivePath && !this.collapsed
    },

    showSentences(){
      return this.unlinkTemplateSection
        ? !this.sentence.sentenceList.empty && !this.collapsed
        : this.inActivePath && !this.sentence.sentenceList.empty && !this.collapsed
    },

    path() {
      return this.sentence.path;
    },
    subSentences() {
      return this.sentence.sentenceList.sentences;
    },
    // hasConditions () {
    // 	return !this.sentence.conditionList.empty
    // },
    isActivePath() {
      return this.activePath.toString() === this.path.toString();
    },
    // parentIsInActivePath () {
    // 		if (this.path.length == 0) return true
    // 	let parentPath = this.path.slice(0, this.path.length - 1)
    // 	return this.activePath.slice(0, parentPath.length).toString() === parentPath.toString()
    // },
    inActivePath() {
      return this.isActivePath || this.activePath.slice(0, this.path.length).toString() === this.path.toString();
    },
    pathIsSameLevel() {
      return this.activePath.length === this.path.length;
    },
    showTooltips() {
      return this.$store.state.showTooltips;
    },
    // isOpen () {
    // 	return !this.collapsed && (this.inActivePath || this.parentIsInActivePath)
    // }
    canDropVariant() {
      if (!this.sentence.sentenceList.empty) {
        return false;
      } else if (
        !this.unlinkTemplateSection
          ? !this.sentence.variantList.empty && this.isActivePath && !this.collapsed
          : !this.sentence.variantList.empty && !this.collapsed
      ) {
        return false;
      } else return true;
    },

    draggingElementIsVariant() {
      return this.$store.state.draggedVariant ? true : false;
    },

    draggingElementIsSentence() {
      return this.$store.state.draggingScenarioGroup;
    },

    draggingElementIsScenario() {
      return this.$store.state.draggedScenario ? true : false;
    },
    // draggingValidation() {
    //   return this.activeDropzone && this.draggingElementIsVariant == false && !this.draggingElementIsSentence;
    // }
    draggingValidation() {
      return this.activeDropzone && this.draggingElementIsScenario;
    },
    isOwnDropZone() {
      return this.$store.state.draggedScenario && this.$store.state.draggedScenario.id == this.sentence.id;
    },
    caretDown() {
      return (
        ((this.inActivePath || this.isActivePath) && !this.collapsed) || (this.unlinkTemplateSection && !this.collapsed)
      );
    },
    linkedAbove() {
      if (this.scenarioIndex > 0) return this.scenarioGroupPriorities[this.scenarioIndex - 1] == this.sentence.priority;
      else return false;
    },
    linkedBelow() {
      return this.scenarioGroupPriorities[this.scenarioIndex + 1] == this.sentence.priority;
    },
    isDemo() {
      return this.$store.state.editorIsDemoVersion;
    }
  },
  methods: {
    cloneBelow(){
      this.$emit('clone-scenario-below')
    },
    
    ungroupPriority(sentence) {
      this.$emit("bump-priority-down", this.scenarioGroupNumber, sentence);
    },

    dragScenario(evt, sentence) {
      if (!this.sentence.sentenceList.empty || !this.draggingElementIsVariant) {
        this.collapsed = true;
        EventBus.$emit('trigger-ghost-element', this.$refs.sentence.clientHeight)
      }
      let header = this.$refs.sentenceHeader;
      this.$emit("start-drag-sentence", evt, sentence, header);
      this.draggingScenario = true;
    },

    handleDrop(evt, sentence) {
      EventBus.$emit("hide-ghost-element")
      evt.stopPropagation();
      this.activeDropzone = false;
      this.draggingScenario = false;
      if (evt.dataTransfer.getData("variantId")) {
        this.handleDropVariant(evt);
      } else if (evt.dataTransfer.getData("sentenceId")) {
        this.$emit("drop-sentence", evt, sentence);
      } else {
        // trying to drop a scenariogroup inside a scenario. thats not gonna work
        EventBus.$emit("drag-and-drop-err", this.$t("errors.sentence-to-scenario"));
      }
    },

    handleDropVariant(evt) {
      if (this.canDropVariant) {
        const itemIndex = evt.dataTransfer.getData("itemIndex");
        this.sentence.variantList.add(this.$store.state.draggedVariant.text);
         if (!evt.altKey){
          this.$store.commit("dropVariantInList", itemIndex);
         } 
      }
      this.$store.commit("dragVariantEnded");
    },

    handleDragendScenario() {
      this.activeDropzone = false;
      this.draggingScenario = false;
      this.collapsed = false;
      this.$store.commit("dragScenarioEnded");
      EventBus.$emit("hide-ghost-element")
    },

    handleDragLeave() {
      this.$nextTick(() => (this.activeDropzone = false));
    },

    variantCount(counter) {
      this.variantCounter = counter - 1;
    },

    newPriorityNumber(newPriority) {
      this.$set(this.sentence, "priority", parseInt(newPriority));
      this.$emit("refresh-list");
      EventBus.$emit("templateChange");
    },

    avoidCollapse() {
      if (this.collapsed == true) {
        this.collapsed = true;
      }
      if (this.collapsed == false) {
        this.collapsed = false;
      }
    },

    toggleActive() {
      // this.collapsed = !this.collapsed
      if (!this.isActivePath) {
        this.$store.dispatch("setActivePath", this.path);
      } else this.collapsed = !this.collapsed;
    },

    onAddSentence(index) {
      let newSentence = this.sentence.sentenceList.addNewSentence("Sentence");
      this.$store.dispatch("setActivePath", newSentence.path);
      EventBus.$emit("templateChange");
    },

    onConvertToSentence(options, globalConvert) {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("sentence.convert-title"),
          description: this.$t("sentence.convert-description"),
          confirmButtonText: this.$t("sentence.convert-confirm"),
          onConfirm: () => {
            if (this.subSentences.length > 0) {
              this.onAddSentence(this.subSentences.length);
            } else {
              let newSentence;
              if (globalConvert) {
                newSentence = this.sentence.convertVariantToSentence(options + 1, true);
              } else {
                newSentence = this.sentence.convertVariantToSentence(options.variantIndex);
              }
              this.$store.dispatch("setActivePath", newSentence.path);
              EventBus.$emit("templateChange");
              // now begin editing condition on this variant
            }
          }
        },
        { width: 350, height: "auto" }
      );
    },

    onRemoveScenario() {
      // todo
    },

    onVariantChange() {
      // if (!this.sentence.texts.length) {
      this.$emit("change");
      // }
    },

    onAddVariant() {
      let variant = this.sentence.addVariant("");
      this.$store.dispatch("setActivePath", this.sentence.path);
      this.$nextTick(() => variant.edit());
    },

    editName() {
      this.$modal.show(
        RenameModal,
        {
          allowEmpty: true,
          title: this.sentence.name
            ? this.$t("rename-scenario-modal.title-rename")
            : this.$t("rename-scenario-modal.title-name"),
          inputName: this.$t("rename-scenario-modal.label"),
          primaryButton: this.$t("rename-scenario-modal.save"),
          inputPlaceholder: this.$t("rename-scenario-modal.label"),
          existingName: this.sentence.name,
          onSave: (name) => {
            if (name != null) this.$set(this.sentence, "name", name || null);
            EventBus.$emit("templateChange");
          }
        },
        { width: 350, height: "auto" }
      );
    }
  },

  watch: {
    isActivePath: {
      immediate: true,
      handler(isActivePath) {
        if (isActivePath && !this.activeDragHandle) {
          this.collapsed = false;
          if (this.$store.state.scrollToPath == true) {
            this.$nextTick(() => {
              this.$el.scrollIntoView({ behavior: "smooth" });
              this.$store.commit("toggleScrollToPath");
            });
          }
        }
      }
    },

    unlinkTemplateSection: {
      immediate: true,
      handler(unlinkTemplateSection) {
        // console.log(this.unlinkTemplateSection)
        if (this.unlinkTemplateSection) {
          if (this.inActivePath || this.isActivePath) {
            this.collapsed = false;
          } else this.collapsed = true;
        }
      }
    }
  },

  components: {
    VariantList,
    Dropdown,
    IconBase,
    IconConverted,
    SentenceAddElementsList
  }
};
</script>

<style lang="less">
.active-dropzone-variant {
  background-color: #6e757a;
}

.sentence {
  padding-left: 11px;
  margin-left: calc(35px - 22px) !important;
  &:not(.bulleted) {
    margin-top: 8px;
  }
  &:first-child {
    border: none;
    padding-top: 0;
  }

  // Drag n drop specific styling for sentence - start
  .dropzone-top,
  .dropzone-bottom {
    display: block;
    height: 2px;
    border: thin dashed #8f979c;
    visibility: hidden;
    transition: 0.1s;
    &.show-dropzone {
      visibility: visible;
      height: 48px;
    }
  }

  &.drop-scenario-under {
    position: relative;
    &::after {
      content: "";
      height: 24px;
      background-color: rgba(110, 117, 122, 0.123);
      border: thin dashed #8f979c;
      display: block;
    }
    .line-number {
      opacity: 0;
    }
  }
  // Drag n drop specific styling for sentence - end
  &.active {
    // active sentence <--
    > .sentence-header {
      background-color: #6e757a;
    }
  }

  .active-line-number {
    color: #fff;
    font-weight: bold;
  }

  // Sentence (scenario) specific styling - start
  .sentence-header {
    position: relative;
    border-radius: 20px 0 0 20px;
    line-height: 24px;
    width: 100%;
    display: grid; // 3 children
    grid-template-columns: 28px minmax(auto, calc(100% - 28px)) 0px;

    // first grid child
    .toggle-collapse {
      margin-right: 8px;
      margin-left: 8px;
      svg {
        font-size: 10px;
        color: #8f979c;
      }
    }

    // second grid child
    .sentence-header-content {
      display: flex;
      cursor: pointer;
      align-items: center;
      .linked-icon {
        font-size: 10px;
        margin: 0 0px 0 2px;
        svg {
          transform: rotate(90deg);
        }
      }
      .icon-converted {
        margin: 1px 0px 0px 2px;
        align-self: center;
      }

      .sentence-name {
        font-weight: 900;
      }

      .name-wrapper {
        display: flex;
        flex-direction: row;

        .rename-wrapper {
          display: flex;
          flex-direction: row;
        }
      }
      .rename {
        visibility: hidden;
        width: 0;
        height: 0;
        margin-left: 4px;
        &.add {
          padding-right: 12px;
          color: var(--orange-web);
          margin-left: 4px;
        }
        &.pencil {
          margin: 0 6px;
        }
      }
    }

    // third grid child
    .actions {
      display: flex;
      flex-direction: row-reverse;
      padding: 0;
      white-space: nowrap;
      visibility: hidden;

      .sentence-action {
        margin: 2px 6px 2px 0;
        padding: 0 6px;
        cursor: pointer;
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;

        &.drag-grip {
          padding: 0 12px;
        }

        &:hover {
          background-color: var(--charcoal);
          border-radius: 100%;
        }

        &.convert-sentence svg {
          transform: rotate(90deg);
        }
      }

      .priority {
        margin-right: 10px;
        padding-top: 1px;
        visibility: visible;
        background-color: rgba(176, 179, 176, 0.144);
        input {
          border: none;
          background-color: inherit;
          width: 32px;
          color: inherit;
          margin: 0;
          text-align: center;
          &::placeholder {
            color: inherit;
          }
          &:focus {
            outline: none;
          }
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input[type="number"] {
          -moz-appearance: textfield;
        }
      }
    }

    // sentence-header hover
    &:hover {
      background: rgba(176, 179, 176, 0.144);
      grid-template-columns: 28px minmax(auto, calc(100% - 170px)) 142px;

      .actions {
        visibility: visible;
        padding: 0 16px;
      }

      .rename {
        width: auto;
        height: auto;
        visibility: visible;
        cursor: pointer;
      }
    }
    &.showing-priority {
      grid-template-columns: 28px minmax(auto, calc(100% - 170px - 40px)) 182px;
    }
    &.open-not-active {
      background: rgba(176, 179, 176, 0.144);
    }
  }

  // Sentence (scenario) specific styling - end

  &.bulleted {
    &:not(:last-child) {
      padding-bottom: 0;
    }
    .sentence-header {
      padding: 0;
    }
    &:not(:first-child) {
      border-top: none;
    }
  }

  .variant-adder {
    // margin: 3px 0 0 33px;
    // padding-left: 33px;
    padding-left: 11px;
    margin-left: 10px;
    margin-top: 3px;
    padding-top: 3px;
    border-left: 1px solid #8f979c;
    &:before {
      content: "\2022";
      transform: scale(1.2);
      font-weight: bold;
      display: inline-block;
      width: 10px;
      opacity: 0.5;
    }

    a {
      color: var(--orange-web) !important;
      // padding-left:8px;
    }
  }

  .variants-and-sentences {
    padding-left: 25px;
    margin-left: 10px;
    margin-top: 3px;
    border-left: 1px solid #8f979c;

    // &:hover{
    // 	background-color: rgba(110, 117, 122, 0.075);
    // }
  }
}
#app .add-rule a {
  color: var(--orange-web);
}
</style>
